//todo make this detect clicks on a tags (or similar), or just remove if too annoying

let _setupFadeOut = function ($element) {
    window.addEventListener('onbeforeunload', function () {
        $element.classList.add('fading-out');
    });
};

document.addEventListener('DOMContentLoaded', () => {
    for (let $element of document.querySelectorAll('.fade-on-load')) {
        _setupFadeOut($element);
    }
});